import React from 'react';
import sus1 from ".././../images/sus2.png";
import { Link } from 'react-router-dom';
export default function PressHero() {
  return (
    <div className="relative w-full max-w-[1200px] h-auto lg:h-[551px] min-h-[551px] bg-[#FAFAFA] overflow-hidden mx-auto p-6 lg:p-0">
      
      {/* Decorative Rotating Background Element (Rectangle 331) */}
      <div 
        className="absolute hidden lg:block w-[491.36px] h-[934.43px] left-[554.12px] top-[-98.37px] bg-[#0D924F]/20"
        style={{ transform: 'rotate(31.74deg)' }}
      />

      {/* Floating Tag Header Row (Frame 2147228649) */}
      <div className="relative lg:absolute lg:left-[36px] lg:top-[64px] flex flex-row items-center gap-[8px] w-full lg:w-[257px] h-[25px]  mb-6 lg:mb-0">
        {/* Press Insight Label (Frame 2147228648) */}
        <div className="flex  flex-row justify-center items-center px-[10px] py-[2px]  h-[25px] bg-[#00AED9] rounded-[4px]">
          <span className="text-[18px] font-normal text-white w-full font-['Inter'] leading-[21px] whitespace-nowrap">
            Press Insight
          </span>
        </div>
        
        {/* Separator Dot (Ellipse 705) */}
        <div className="w-[10px] h-[10px] bg-[#D9D9D9] rounded-full shrink-0" />
        
        {/* Category Description */}
        <span className="text-[18px] font-normal text-[#344054]  leading-[21px] whitespace-nowrap">
          Clean Transport
        </span>
      </div>

      {/* Main Feature Image (image 141) */}
      <div 
        className="relative lg:absolute w-full lg:w-[539px] h-[300px] lg:h-[474px] lg:left-[618px] lg:top-[calc(50%-237.5px)] bg-cover bg-center rounded-[8px]   mb-8 lg:mb-0"
      >
        <img src={sus1} alt="Press Hero Image" className="w-full h-full object-cover rounded-[8px] " loading="lazy" /> 
      </div>

      {/* Text Copy & CTA Content Wrapper (Frame 2147228651) */}
      <div className="relative lg:absolute lg:left-[32px] lg:top-[129px] flex flex-col items-start gap-[24px] w-full lg:w-[522px] h-auto lg:h-[365px] ">
        
        {/* Text Headers Block (Frame 2147228650) */}
        <div className="flex flex-col items-start gap-[16px] w-full lg:w-[520px]">
          <h1 className="w-full text-[32px] sm:text-[40px] lg:text-[48px] font-semibold text-[#141414] leading-[110%] tracking-[-0.04em] font-['Inter']">
            Introducing Low-cost mobility for Nigeria’s transport system - Netzence
          </h1>
          <p className="w-full text-[16px] sm:text-[18px] font-normal text-[#3B3B3B] leading-[120%] font-['Inter'] font-feature-settings-['salt','cv01','cv03','cv04']">
            Nigeria’s mobility ecosystem is shifting. Rising fuel prices and congestion have made transportation costs unsustainable for many commuters.
          </p>
        </div>

        {/* Primary CTA Action Button (Small buttons) */}
        <Link to="/blogpost1" className="flex flex-row justify-center items-center px-[15px] py-[12px] w-[147px] h-[47px] bg-[#0D924F] border-2 border-[#006633] rounded-[8px] hover:bg-[#0b7c43] active:scale-98 transition-all group duration-200">
          <span className="text-[16px]  text-white ">
         Discover more
          </span>
          {/* Arrow 2 is display: none in styles; hidden class mapping applied */}
          <span className="hidden w-[18px] border border-white ml-2 transition-transform group-hover:translate-x-1" />
        </Link>

      </div>
    </div>
  );
}